import Vue from 'vue';
import Component from 'vue-class-component';

import BbForm from 'common/components/BbForm';
import BbField from 'common/components/BbField';

import CatalogClientData from 'assets/graphql/queries/catalog/CatalogClientData.graphql';

import moment from 'common/deps/moment';
import currency from 'common/filters/currency';

Vue.filter('currency', currency);
@Component({
  apollo: {
    auth_user: {
      query: CatalogClientData,
      result({ data }) {
        this.form.firstName = data.auth_user.first_name;
        this.form.lastName = data.auth_user.last_name;
        this.form.email = data.auth_user.email;
        this.form.phone = data.auth_user.phone;
      },
    },
  },
  props: {
    reservationConfig: {
      type: Object,
      required: true,
      description: 'data from query CatalogReservation.graphql',
    },
    dateChosen: {
      type: Object,
      required: true,
      description: 'data selected in previus step',
    },
    disabled: {
      type: Boolean,
      default: false,
      description:
        'when the reservation is creating, this will disable every input',
    },
    reservationError: {
      type: String,
      default: '',
      description:
        'error comming from the backend when we press "confirmar" button',
    },
    isReservationBuy: {
      type: Boolean,
      default: false,
    },
    activity: {
      type: Object,
      required: false,
    },
  },
  components: {
    BbForm,
    BbField,
  },
})
export default class CatalogClientDataStepComponent extends Vue {
  errors = [];
  form = {
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    comments: null,
  };
  clarificationAccepted = false;
  clarificationMessage = '';

  created() {
    if (this.reservationConfig?.special_clarification) {
      this.clarificationMessage = this.reservationConfig.special_clarification;
    }
  }

  toggleTermAndConditions() {
    this.clarificationAccepted = !this.clarificationAccepted;
  }

  getDateFormatted() {
    const { date, appointment } = this.dateChosen;

    /* This line is to avoid console errors when moving accross the steps and changing data */
    if (!appointment) return new Date();

    let date_ = moment(`${date.date}T${appointment.time}`).format(
      'DD/MM/YYYY - H:mm a',
    );

    let dateFormated = moment(`${date.date}T${appointment.time}`).format(
      'DD/MM/YYYY',
    );

    if (appointment.end_time) {
      let date_init = moment(appointment.time, 'HH:mm:ss').format('H:mm a');
      let date_range = moment(appointment.end_time, 'HH:mm:ss').format(
        'H:mm a',
      );
      date_ = `${dateFormated} - llegada entre las ${date_init} y las ${date_range}`;
    }

    return `${date_}`;
  }

  get lowerCasedError() {
    if (this.reservationError) return this.reservationError.toLowerCase();
    return '';
  }

  submitForm() {
    this.$emit('selectClientDataCompleted', { ...this.form });
  }
}
